import { redirect } from 'react-router-dom';
import { getApiChara } from '../../util/getApi';
import { getAuthToken, clearAuthToken } from '../../util/auth';
export async function action() {
  const token = getAuthToken();
  const apiChar = getApiChara();
  const apiUrl = `${apiChar}/logout/logout`;

  if (token && token !== 'EXPIRED') {
    try {
      await fetch(apiUrl, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });
    } catch (error) {
      console.error("Error calling logout endpoint: ", error);
    }
  }

  clearAuthToken();
  return redirect('/');
}